module.exports = __webpack_public_path__ + "assets/img/16.c1b56973.png";